import { combineReducers } from 'redux';
import exploreFilters from './explore-filters-reducer';
import exploreTabs from './explore-tabs-reducer';
import exploreTimeline from './explore-timeline-reducer';

const exploreReducer = combineReducers({
  exploreFilters,
  exploreTabs,
  exploreTimeline,
});

export default exploreReducer;
